import React from 'react';

function ArrowNext() {
  return (
    <svg
      width='80'
      height='80'
      viewBox='0 0 80 80'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_d_99_3087)'>
        <circle cx='40' cy='40' r='25' fill='white' />
      </g>
      <path
        d='M32 35H48M48 35L42 29M48 35L42 41'
        stroke='#6479D6'
        strokeWidth='2'
        strokeLinejoin='round'
        strokeLinecap='round'
        transform='translate(1, 4)'
      />
      <defs>
        <filter
          id='filter0_d_99_3087'
          x='0'
          y='0'
          width='80'
          height='80'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='5' />
          <feGaussianBlur stdDeviation='7.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_99_3087'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_99_3087'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  );
}

export default ArrowNext;
